var React = require('react');

function TableSortDownIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .table-sort-down-icon-svg {\n        fill: #c7c7c7;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","className":"table-sort-down-icon-svg","d":"M820,280h2v5h-2v-5Zm5,5.01-4.007,5-4.007-5H825Z","transform":"translate(-817 -280)","key":1})]);
}

TableSortDownIcon.defaultProps = {"width":"8","height":"10","viewBox":"0 0 8 10"};

module.exports = TableSortDownIcon;

TableSortDownIcon.default = TableSortDownIcon;
